import { useSelector } from "react-redux";
import { selectIsNutritionClinic } from "../../store/slices/authSlice";
import CreatePatientWizard from "../../components/patients/createWizard/CreatePatientWizard";
import NutritionCreateWizard from "../../components/patients/createWizard/nutrition/NutritionCreateWizard";

/**
 * /dashboard/patients/new — thin route wrapper around the new-patient wizard.
 *
 * Nutrition clinics get their own wizard (a full replacement — no fallback to
 * the classic one); every other clinic type gets the classic wizard unchanged.
 *
 * The route (and this component) must stay: the onboarding tour navigates
 * here and anchors to `.create-patient-page .form-container`, and detects
 * creation success by the URL changing to /dashboard/patients/:id (or, for a
 * nutrition clinic, /dashboard/nutrition/:id).
 */
function CreatePatientPage() {
  const isNutritionClinic = useSelector(selectIsNutritionClinic);

  return (
    <div className="create-patient-page">
      {isNutritionClinic ? <NutritionCreateWizard /> : <CreatePatientWizard />}
    </div>
  );
}

export default CreatePatientPage;
